import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Radio, message } from 'antd';
import LeftMenu from './components/LeftMenu';
import Drawer from '../../components/Drawer';
import BoardMode from './components/BoardMode';
import MapMode from '../../components/MapMode';
import { RootState } from '../../redux/store';
import TabButton from '../../components/TabButton';
import SelectComp from './components/SelectComp';
import ButtonRadio from '../../components/ButtonRadio';
import { Mode } from './util';
import './index.scss';
import BoardGroup from '../../components/BoardGroup';
import { request } from '../../fetch/core';
import classNames from 'classnames';
import { HttpStatusCode } from '../../fetch/core/constant';
import {
  addGlobalEventListener,
  removeGlobalEventListener,
  sendGlobalEvent,
} from '../../utils/emit';
import {
  GlobalEventName,
  CockpitMode,
  CockpitType,
  CLSTAG,
} from '../../utils/constant';
import { cloneDeep } from 'lodash';
import { formatMapData, getPermissionById, isEmpty } from '../../utils';
import ActionType, {
  actionFetchBasicInfo,
  actionMergeAlarmToMenu,
  actionSendSocketData,
} from '../../redux/action/common';
import { ConnectionState, VehicleIssue } from '../../redux/type';
import OrderList from '../../components/OrderList';
import MultiSelectComp from './components/MultiSelectComp';
import CommonBreadCrumb, { BreadConfig } from '@/components/Common/BreadCrumb';
import { analyzeLog, clstagStr } from '../../utils/util';
import ScheduleModel from '@/components/ScheduleModel/SchedulemModel';
import { Method } from '@/fetch/core/util';
const map1 = new Map([
  [
    'CONNECTION_LOST',
    { label: '失联', value: 0, clstag: CLSTAG.ConnectionLost },
  ],
  ['VEHICLE_CRASH', { label: '防撞', value: 0, clstag: CLSTAG.VehicleCrash }],
  [
    'HARDWARE_ERROR',
    { label: '硬件异常', value: 0, clstag: CLSTAG.HardwareError },
  ],
  [
    'NETWORK_SIGNAL',
    { label: '网络信号', value: 0, clstag: CLSTAG.NetworkSignal },
  ],
  [
    'MANUAL_REPORT',
    { label: '人工告警', value: 0, clstag: CLSTAG.ManualReport },
  ],
  ['CALIBRATION_ERROR', { label: '标定', value: 0, clstag: '' }],
  [
    'SENSOR_ERROR',
    { label: '传感器异常', value: 0, clstag: CLSTAG.SensorError },
  ],
  [
    'OPERATION_ALARM',
    { label: '运营告警', value: 0, clstag: CLSTAG.OperationAlarm },
  ],
  ['BOOT_ALARM', { label: '开机异常', value: 0, clstag: CLSTAG.BootAlarm }],
  [
    'INTERSECTION_ABNORMAL',
    { label: '路口异常', value: 0, clstag: CLSTAG.IntersectionAbnormal },
  ],
  ['STOP', { label: '停车', value: 0, clstag: CLSTAG.Stop }],
  ['CLOUD_WARN', { label: '云端预警', value: 0, clstag: CLSTAG.CloudWarn }],
  ['LOW_BATTERY', { label: '电量', value: 0, clstag: CLSTAG.LowBattery }],
  ['LOW_PRESSURE', { label: '胎压', value: 0, clstag: CLSTAG.LowPressure }],
]);

/**
 *
 * @param {City} city 城市
 * @param {Station} station 站点
 * @param {Vehicle} vehicle 车辆
 * @return {MenuItem[]}
 */
export function formatMenuData(
  city: City,
  station: Station,
  vehicle: Vehicle
): any[] {
  const stationsByCity = new Map<string, StationItem[]>();
  const vehiclesByCity = new Map<string, VehicleItem[]>();
  const vehiclesByStation = new Map<string, VehicleItem[]>();
  const unattendedCities = new Set<string>();
  const unattendedStations = new Set<string>();

  Object.values(station).forEach((stationItem: StationItem) => {
    const cityKey = String(stationItem.pid);
    const stationsInCity = stationsByCity.get(cityKey) || [];
    stationsInCity.push(stationItem);
    stationsByCity.set(cityKey, stationsInCity);
  });

  Object.values(vehicle).forEach((vehicleItem: VehicleItem) => {
    const cityKey = String(vehicleItem.gid);
    const stationKey = String(vehicleItem.pid);
    const vehiclesInCity = vehiclesByCity.get(cityKey) || [];
    const vehiclesInStation = vehiclesByStation.get(stationKey) || [];

    vehiclesInCity.push(vehicleItem);
    vehiclesInStation.push(vehicleItem);
    vehiclesByCity.set(cityKey, vehiclesInCity);
    vehiclesByStation.set(stationKey, vehiclesInStation);

    if (!vehicleItem.attentionState) {
      unattendedCities.add(cityKey);
      unattendedStations.add(stationKey);
    }
  });

  return Object.values(city).map((cityItem: any) => {
    const cityKey = String(cityItem.id);
    const stationsInCity = stationsByCity.get(cityKey) || [];
    const vehiclesInCity = vehiclesByCity.get(cityKey) || [];
    const cObj: any = {
      abnormal: cityItem.abnormalNum || 0,
      onlineNum: vehiclesInCity.filter(
        (v: VehicleItem) => v.originState === 'NORMAL'
      ).length,
      total: cityItem.total || 0,
      title: cityItem.name,
      titleText: cityItem.name,
      level: 1,
      parentKey: '',
      id: cityItem.id,
      key: cityKey,
      attentionState: !unattendedCities.has(cityKey),
      children: [],
    };

    stationsInCity.forEach((stationItem: StationItem) => {
      const stationKey = String(stationItem.id);
      const vehiclesInStation = vehiclesByStation.get(stationKey) || [];
      const sObj: any = {
        title: stationItem.name,
        abnormal: stationItem.abnormalNum || 0,
        onlineNum: vehiclesInStation.filter(
          (v: VehicleItem) => v.originState === 'NORMAL'
        ).length,
        total: stationItem.total || 0,
        level: 2,
        id: stationItem.id,
        titleText: stationItem.name,
        attentionState: !unattendedStations.has(stationKey),
        parentKey: cityKey,
        key: `${cityKey}-${stationKey}`,
        children: vehiclesInStation.map((vehicleItem: VehicleItem) => ({
          attentionState: vehicleItem.attentionState,
          vehicleState: vehicleItem.vehicleState,
          tagList: vehicleItem.tagList,
          title: vehicleItem.name,
          titleText: vehicleItem.name,
          number: vehicleItem.number,
          level: 3,
          parentKey: `${cityKey}-${stationKey}`,
          key: `${cityKey}-${stationKey}-${vehicleItem.name}`,
          id: vehicleItem.name,
          children: [],
        })),
      };

      cObj.children.push(sObj);
    });

    return cObj;
  });
}

let timer: any = null;
let highlightTimer: any = null;
let selectStationId: any = -1;
let vehicleArr: any[] = [];
const RealTime = () => {
  const dispatch = useDispatch();
  const common = useSelector((state: RootState) => state.common);
  const cockpitInfo = useSelector((state: RootState) => state.cockpitInfo);
  const login = useSelector((state: RootState) => state.login);
  const { cockpitMode, currentCockpit } = cockpitInfo;

  const {
    city,
    station,
    vehicle,
    realTimeBoardData,
    realTimeVehiclesPosition,
    alarmEventList,
    basicInfoTimeStamp,
    mapScheduleUpdate,
    connectionState,
  } = common;
  const [mapData, setMapData] = useState<{
    city: Record<string, any>;
    station: Record<string, any>;
    vehicle: Record<string, any>;
    stop: Record<string, any>;
    finishedRoutingPoint: Record<string, RoutingCoordinate[]>;
    currentRoutingPoint: RoutingPathMap;
    zoom: number;
    centerPoint?: [number, number];
  }>({
    city: {},
    station: {},
    vehicle: {},
    stop: {},
    finishedRoutingPoint: {},
    currentRoutingPoint: {},
    zoom: 5,
  });
  const vehicleStates = JSON.stringify(
    Object.values(vehicle).map((item: any) => item.vehicleState)
  );
  const menuData = useMemo(
    () => formatMenuData(city, station, vehicle),
    [city, station, vehicle, basicInfoTimeStamp, vehicleStates]
  );
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const [useCaseList, setUseCaseList] = useState<any[]>([]);
  const [business, setBusiness] = useState<any[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [stopData, setStopData] = useState<any>(null);
  const [modalTitle, setModalTitle] = useState('');
  const [visible, setVisible] = useState(false);
  const [scheduleVehicle, setScheduleVehicle] = useState('');
  const [searchCondition, setSearchCondition] = useState({
    vehicleBusinessType: '',
    vehicleUseCaseList: [],
    sortType: 'BUSINESS_TYPE',
    currentCategory: 'CONNECTION_LOST',
  });
  const [alarmEventBtnList, setAlarmEventBtnList] = useState(map1);
  const [selectedMenuData, setSelectedMenuData] = useState<any>({});
  const [activeMode, setActiveMode] = useState<'boardMode' | 'mapMode'>(
    'boardMode'
  );
  const [filterSystemState, setFilterSystemState] =
    useState<string>('CONNECTION_LOST');
  const [activeSubTabId, setActiveSubTabId] = useState<string>();
  const [tabBtnListMap, setTabBtnListMap] = useState<any>(null);
  const [boardListKey, setBoardListKey] = useState(0);
  const [menuKey, setMenuKey] = useState(0);
  const [currentLevel, setCurrentLevel] = useState('nation');
  const [breadConfig, setBreadConfig] = useState<BreadConfig[]>([
    {
      label: '全国',
      key: 'nation',
      onClick: () => {
        handleClickNationLevel();
      },
    },
  ]);
  const [cockpitNum, setCockpitNum] = useState<any>(null);
  /**
   * 点击面包屑-全国，切换到全国层级
   */
  const handleClickNationLevel = () => {
    timer && clearTimeout(timer);
    setCurrentLevel('nation');
    unSubscripeScheduleChange();
    const data = formatMapData({
      nation: true,
      zoom: 5,
      showFinishedRouting: false,
    });
    setMapData(data);
    setSelectedMenuData({});
    setMenuKey(Date.now());
    setOpenKeys([]);
    setBreadConfig([
      {
        label: '全国',
        key: 'nation',
        onClick: () => {
          handleClickNationLevel();
        },
      },
    ]);
  };

  /**
   * 切换地图模式/看板模式
   * 切换到地图模式默认关闭已打开的菜单
   * @param {Object} mode 模式类型
   */
  const handleChangeMode = (mode: any) => {
    setActiveMode(mode.value);
    if (mode.value === 'mapMode') {
      handleClickNationLevel();
    }
  };

  /**
   * 获取菜单数据
   */
  useEffect(() => {
    if (login.resourceList?.length > 0) {
      if (getPermissionById('spv_cockpitMode')) {
        request({
          method: Method.POST,
          path: '/monitor/web/user/getCockpitStatus',
        }).then((res) => {
          if (
            res?.code === HttpStatusCode.Success &&
            res?.data?.cockpitTeamNumber &&
            res?.data?.cockpitNumber &&
            res?.data?.cockpitType === CockpitType.MONITOR_SEAT
          ) {
            getDataPermission(
              'cockpit',
              res.data?.cockpitNumber,
              searchCondition
            );
            setCockpitNum(res.data?.cockpitNumber);
          } else {
            setCockpitNum('user');
            getDataPermission('user', null, searchCondition);
          }
        });
      } else {
        setCockpitNum('user');
        getDataPermission('user', null, searchCondition);
      }
    }
  }, [login.resourceList]);

  const getDataPermission = (
    type: 'user' | 'cockpit',
    cockpitNumber: any,
    searchVal: any
  ) => {
    let requestData: RequestOptions;
    if (type === 'user') {
      requestData = {
        method: 'POST',
        path: '/monitor/web/basic/user_vehicle',
        body: {
          useCaseList: searchVal.vehicleUseCaseList,
          businessType: searchVal.vehicleBusinessType,
        },
      };
      request(requestData).then((res) => {
        dispatch(actionFetchBasicInfo(res));
      });
    } else if (type === 'cockpit') {
      requestData = {
        method: 'POST',
        path: '/monitor/web/basic/getCockpitVehicleTree',
        body: {
          useCaseList: searchVal.vehicleUseCaseList,
          businessType: searchVal.vehicleBusinessType,
          cockpitNumber: cockpitNumber,
        },
      };
      request(requestData).then((res) => {
        dispatch(actionFetchBasicInfo(res));
      });
    }
  };

  /**
   * 获取车辆用途列表
   */
  useEffect(() => {
    request({
      path: '/monitor/web/basic/user_vehicle_type',
      method: Method.POST,
      body: {
        dataType: 'usecase',
      },
    }).then((res) => {
      if (res?.code === HttpStatusCode.Success) {
        let all = 0;
        const arr = res.data.map((item: any) => {
          all += item.count;
          return {
            label: item.name,
            value: item.type,
            count: item.count,
            labelCount: `${item.name}(${item.count})`,
          };
        });
        arr.unshift({
          label: '全部',
          value: '',
          count: all,
          labelCount: `全部(${all})`,
        });
        setUseCaseList(arr);
      }
    });
  }, []);

  /**
   * 获取车辆业务类型
   */
  useEffect(() => {
    request({
      path: '/monitor/web/basic/user_vehicle_type',
      method: Method.POST,
      body: {
        dataType: 'business',
      },
    }).then((res) => {
      if (res?.code === HttpStatusCode.Success) {
        let all = 0;
        const arr =
          res?.data?.map((item: any) => {
            all += item.count;
            return {
              label: item.name,
              value: item.type,
              count: item.count,
            };
          }) || [];
        arr.unshift({
          label: '全部',
          value: '',
          count: all,
        });
        setBusiness(arr);
      }
    });
  }, []);

  /**
   * 看板数据变化时更新分组Tab上的统计数字
   */
  useEffect(() => {
    if (realTimeBoardData) {
      const _CountMap = new Map([
        [
          'CONNECTION_LOST',
          {
            label: '失联及异常',
            value: realTimeBoardData.errorSize,
            clstag: CLSTAG.ConnectionLostAbnormal,
          },
        ],
        [
          'NORMAL',
          {
            label: '正常',
            value: realTimeBoardData.normalSize,
            clstag: CLSTAG.Normal,
          },
        ],
        [
          'OFFLINE',
          {
            label: '离线',
            value: realTimeBoardData.offlineSize,
            clstag: CLSTAG.Offline,
          },
        ],
        [
          'ALL',
          {
            label: '全部',
            value: realTimeBoardData.allSize,
            clstag: CLSTAG.All,
          },
        ],
        [
          'INTERESTED',
          {
            label: '收藏',
            value: realTimeBoardData.interestedSize,
            clstag: CLSTAG.Collected,
          },
        ],
      ]);
      setTabBtnListMap(_CountMap);
    }
  }, [realTimeBoardData]);

  /**
   * 订阅站点下车辆的调度变化
   * @param {string[]} vehicles 车号列表
   */
  const subscripeScheduleChange = (vehicles: string[]) => {
    const requestData = {
      eventType: ActionType.MAP_VEHICLE_SCHEDULE_REQUEST,
      data: {
        vehicleName: vehicles,
      },
    };

    dispatch(actionSendSocketData(JSON.stringify(requestData)));
  };

  /**
   * 取消调度状态变化的订阅
   */
  const unSubscripeScheduleChange = () => {
    const requestData = {
      eventType: ActionType.MAP_VEHICLE_SCHEDULE_CANCEL_REQUEST,
    };
    dispatch(actionSendSocketData(JSON.stringify(requestData)));
  };

  /**
   *
   * @param {Object} value  选中的tab数据
   */
  const handleChangeTab = (value: { tabId: string; [key: string]: any }) => {
    setFilterSystemState(value.tabId);
    setSearchCondition({
      ...searchCondition,
      currentCategory: value.tabId,
      sortType:
        value.tabId === 'ALL' || value.tabId === 'OFFLINE'
          ? ''
          : searchCondition.sortType,
    });
    setBoardListKey(Date.now());
  };

  /**
   *
   * @param {Object} value 选中的subTab数据
   */
  const handleChangeSubTab = (value: { tabId: string; [key: string]: any }) => {
    setActiveSubTabId(value.tabId);
  };

  /**
   *
   * @param {any} e 单选组件引用
   */
  const onChange = (e: any) => {
    const selectedValue = e.target.value;
    // analyzeLog('sortType', `{"sortType":${selectedValue}}`);
    setSearchCondition({
      ...searchCondition,
      sortType: selectedValue,
    });
    setBoardListKey(Date.now());
  };

  /**
   *
   * @param {any} value 车辆类型
   */
  const handleChangeUseCaseList = useCallback(
    (value: any) => {
      let newSearchCondition = {
        ...searchCondition,
        vehicleUseCaseList: value,
      };
      setSearchCondition(newSearchCondition);
      getDataPermission(
        currentCockpit.cockpitNumber ? 'cockpit' : 'user',
        currentCockpit.cockpitNumber,
        newSearchCondition
      );
      setBoardListKey(Date.now());
    },
    [searchCondition.vehicleBusinessType, searchCondition.currentCategory]
  );

  const handleChangeBusinessType = (type: any) => {
    analyzeLog('vehicleBusinessType', `{"vehicleBusinessType":${type}}`);
    let newSearchCondition = {
      ...searchCondition,
      vehicleBusinessType: type,
    };
    setSearchCondition(newSearchCondition);
    getDataPermission(
      currentCockpit.cockpitNumber ? 'cockpit' : 'user',
      currentCockpit.cockpitNumber,
      newSearchCondition
    );
    setBoardListKey(Date.now());
  };

  /**
   *
   * @param {number} stationId 站点id
   * @param {string[]} vehicles 车号列表
   * @return {boolean}
   */
  const getVehicleInStation = (
    stationId: number | string,
    vehicles: string[]
  ) => {
    if (!stationId || isEmpty(vehicles)) {
      return false;
    }
    const requestData: RequestOptions = {
      path: '/monitor/web/map/vehicle/list',
      method: 'POST',
      body: {
        stationId: stationId,
        vehicleName: vehicles,
      },
    };
    request(requestData).then((res) => {
      if (res?.code === HttpStatusCode.Success && res?.data) {
        const data = res.data;
        const newMapData = formatMapData({
          nation: false,
          station: {
            [data?.station?.id]: data?.station,
          },
          vehicle: data?.vehicle,
          zoom: 17,
          showFinishedRouting: false,
        });
        setMapData(newMapData);
        setSelectedMenuData({
          stationId,
          vehicleName: vehicles,
        });
      } else {
        res?.message && message.error(res?.message);
      }
    });
  };

  /**
   *
   * @param {string[]} keys 站点菜单key-parentKey
   */
  const onMenuOpenChange = (keys: string[]) => {
    if (activeMode === 'mapMode') {
      if (keys.length === 1) {
        handleClickCityLevel(Number(keys[0]));
      } else if (keys.length === 2) {
        handleClickStationIcon(Number(keys[1]));
      }
    } else {
      unSubscripeScheduleChange();
    }
  };

  /**
   * 点击城市图标/城市面包屑/城市menuItem进入城市级地图
   * @param {number} cityId 城市Id
   */
  const handleClickCityLevel = (cityId: number): void => {
    setOpenKeys([cityId.toString()]);
    setCurrentLevel('city');
    unSubscripeScheduleChange();
    const cityName = city[cityId].name;
    const stations: any = {};
    Object.values(station)
      .filter((v: any) => v.pid === cityId)
      .forEach((v: any) => {
        stations[v.id] = v;
      });
    const vehicles: any = Object.values(vehicle)
      .filter((v: any) => v.gid === cityId)
      .map((v: any) => v.name);
    setSelectedMenuData({
      vehicleName: vehicles,
    });
    getVehiclesRealtimePosition(vehicles);
    setMapData({
      city: {},
      station: stations,
      vehicle: {},
      stop: {},
      finishedRoutingPoint: {},
      currentRoutingPoint: {},
      zoom: 12,
    });
    setBreadConfig([
      {
        label: '全国',
        key: 'nation',
        onClick: () => {
          handleClickNationLevel();
        },
      },
      {
        key: cityId,
        label: cityName,
        onClick: (e) => {
          handleClickCityLevel(cityId);
        },
      },
    ]);
  };

  /**
   * 点击站点图标进入站点级地图
   * @param {number} stationId 站点Id
   */
  const handleClickStationIcon = (stationId: number) => {
    setCurrentLevel('station');
    selectStationId = stationId;
    const cityId = station[stationId].pid;
    setOpenKeys([cityId.toString(), `${cityId}-${stationId}`]);
    const cityName = city[cityId].name;
    const stationName = station[stationId].name;
    const vehicles = Object.values(vehicle)
      .filter((v: any) => v.pid == stationId)
      .map((v: any) => v.name);
    vehicleArr = vehicles;
    getVehicleInStation(stationId, vehicles);
    subscripeScheduleChange(vehicles);
    getVehiclesRealtimePosition(vehicles, stationId);
    setBreadConfig([
      {
        label: '全国',
        key: 'nation',
        onClick: () => {
          handleClickNationLevel();
        },
      },
      {
        key: cityId,
        label: cityName,
        onClick: (e) => {
          handleClickCityLevel(cityId);
        },
      },
      {
        label: stationName,
        key: stationId,
        onClick: () => {},
      },
    ]);
  };

  /**
   * 点击定位按钮，地图路线高亮显示
   * @param {string} vehicleName 车号
   */
  const onPositionBtnClick = (vehicleName: any) => {
    clearTimeout(highlightTimer);
    const stationId = vehicle[vehicleName].pid;
    if (selectStationId !== stationId) {
      handleClickStationIcon(stationId);
    }
    highlightTimer = setTimeout(() => {
      sendGlobalEvent(GlobalEventName.JDX_HIGHLIGHT_ROUTING_PATH, {
        vehicleName,
      });
    }, 1000);
  };

  /**
   * 更新失联及异常分组下子标签上的数字
   * @param {any} groupData 分组数据
   */
  const updateGroupTotal = (groupData: any) => {
    const newAlarmEventBtnList = cloneDeep(alarmEventBtnList);
    for (const [k, v] of groupData.entries()) {
      const data: any = newAlarmEventBtnList.get(k);
      data.value = v.total;
    }
    setAlarmEventBtnList(newAlarmEventBtnList);
  };

  /**
   * 获取城市/站点下车辆的实时位置信息
   * @param {string[]} vehicles
   * @param {number | string} stationId 站点Id
   */
  const getVehiclesRealtimePosition = (
    vehicles: string[],
    stationId?: number | string
  ) => {
    const requestData = {
      eventType: ActionType.MAP_VEHICLE_POSITION_REQUEST,
      data: {
        stationId,
        vehicleName: vehicles,
      },
    };

    dispatch(actionSendSocketData(JSON.stringify(requestData)));
  };

  /**
   * 地图模式下开启轮询获取车辆位置接口
   */
  useEffect(() => {
    if (
      activeMode === 'mapMode' &&
      selectedMenuData.vehicleName &&
      realTimeVehiclesPosition.timeStamp != 0
    ) {
      timer = setTimeout(() => {
        clearTimeout(timer);
        getVehiclesRealtimePosition(
          selectedMenuData.vehicleName,
          selectedMenuData.stationId
        );
      }, 5000);
    }

    return () => {
      timer && clearTimeout(timer);
    };
  }, [selectedMenuData, activeMode, realTimeVehiclesPosition.timeStamp]);

  /**
   * 车辆实时位置变化，以及报警事件变化时，更新地图上车辆图标的位置和状态
   */
  useEffect(() => {
    if (realTimeVehiclesPosition.timeStamp != 0 && currentLevel !== 'nation') {
      const temp: any = Object.entries(realTimeVehiclesPosition.data);
      for (const [k, v] of temp) {
        mapData.vehicle[k] = Object.assign({}, mapData.vehicle[k], v, {
          hasAlarmEvent: alarmEventList[k],
        });
      }
      setMapData({
        ...mapData,
        vehicle: {
          ...mapData.vehicle,
        },
      });
    }
  }, [realTimeVehiclesPosition.timeStamp, Object.keys(alarmEventList).length]);

  useEffect(() => {
    if (mapScheduleUpdate.timeStamp !== 0) {
      getVehicleInStation(selectStationId, vehicleArr);
    }
  }, [mapScheduleUpdate.timeStamp]);

  /**
   * 切换筛选，站点数据变化之后，重新初始化地图
   */
  useEffect(() => {
    const data = formatMapData({
      nation: false,
      zoom: 5,
      station: station,
      showFinishedRouting: false,
    });
    setMapData({
      ...mapData,
      ...data,
    });
    timer && clearTimeout(timer);
  }, [JSON.stringify(Object.keys(station)), basicInfoTimeStamp]);

  useEffect(() => {
    return () => {
      selectStationId = -1;
      vehicleArr = [];
      timer && clearTimeout(timer);
      timer = null;
    };
  }, []);

  /**
   * 监听ws连接状态，重连时发送注册消息
   */
  useEffect(() => {
    if (
      connectionState === ConnectionState.OK &&
      activeMode === 'mapMode' &&
      selectStationId !== -1 &&
      !isEmpty(vehicleArr)
    ) {
      subscripeScheduleChange(vehicleArr);
    }
  }, [connectionState, activeMode, selectStationId, vehicleArr]);

  // 每10s关联一次报警事件到菜单上
  useEffect(() => {
    let interval: any = null;
    if (connectionState === ConnectionState.OK) {
      interval = setInterval(() => {
        dispatch(actionMergeAlarmToMenu());
      }, 10000);
    }
    return () => {
      interval && clearInterval(interval);
    };
  }, [connectionState]);

  const renderTabBtnList = () => {
    if (!tabBtnListMap) {
      return;
    }
    const tabList: any = [];
    for (const [k, v] of tabBtnListMap.entries()) {
      if (k === 'INTERESTED' && cockpitMode !== CockpitMode.MONITOR) {
        continue;
      }
      const bar = (
        <TabButton
          key={k}
          tabId={k}
          title={v.value}
          subTitle={v.label}
          isActive={k === filterSystemState}
          readOnly={activeMode === 'mapMode'}
          onClick={handleChangeTab}
          clstag={v.clstag}
        />
      );
      tabList.push(bar);
    }
    return tabList;
  };
  const renderSubTabBtnList = () => {
    const btnList = [];
    if (filterSystemState === 'CONNECTION_LOST') {
      for (const [k, v] of alarmEventBtnList.entries()) {
        const bar = (
          <TabButton
            key={k}
            tabId={k}
            title={v.label}
            subTitle={v.value}
            isActive={k === activeSubTabId}
            type={2}
            onClick={handleChangeSubTab}
            clstag={v.clstag}
          />
        );
        btnList.push(bar);
      }
    }
    return (
      <>
        <div className="tab-btn-wrapper">{btnList}</div>
        {(filterSystemState === 'CONNECTION_LOST' ||
          filterSystemState === 'NORMAL') && (
          <>
            <span style={{ color: '#fff', marginRight: '10px' }}>排序方式</span>
            <Radio.Group onChange={onChange} defaultValue={'BUSINESS_TYPE'}>
              <Radio value={'BUSINESS_TYPE'}>
                <i clstag={clstagStr(CLSTAG.MultiPage_Sort_BusinessType)}>
                  业务
                </i>
              </Radio>
              <Radio value={'VEHICLE_NAME'}>
                <i clstag={clstagStr(CLSTAG.MultiPage_Sort_VehicleName)}>
                  车号
                </i>
              </Radio>
              <Radio value={'POWER'}>
                <i clstag={clstagStr(CLSTAG.MultiPage_Sort_Power)}>电量</i>
              </Radio>
              <Radio value={'STATION'}>
                <i clstag={clstagStr(CLSTAG.MultiPage_Sort_Station)}>营业部</i>
              </Radio>
            </Radio.Group>
          </>
        )}
      </>
    );
  };
  const collapseNode = (
    <div className="search-icon">
      <i></i>
      搜索
    </div>
  );

  const handleClickStopItem = (stopData: any) => {
    setModalVisible(true);
    setStopData(stopData);
  };

  const updateModalTitle = (info: any) => {
    if (info.data) setModalTitle(info.data.stopName);
  };
  const handleScheduleModel = (e: string) => {
    setScheduleVehicle(e);
    setVisible(!visible);
  };

  return (
    <>
      <div className="real-time-content">
        <Drawer
          defaultOpened={true}
          width={'17.8%'}
          direction={'left'}
          collapseNode={collapseNode}
        >
          <div className="left-area">
            <div className="left-menu-content">
              <LeftMenu
                key={menuKey}
                openKeys={openKeys}
                setOpenKeys={setOpenKeys}
                activeMode={activeMode}
                menuData={menuData}
                onMenuOpenChange={onMenuOpenChange}
                onPositionBtnClick={onPositionBtnClick}
              />
            </div>
          </div>
        </Drawer>
        <div className="right-content">
          <div className="filter-option-area">
            <div
              className={classNames('line1', {
                mapModeBar: activeMode === 'mapMode',
              })}
            >
              <div className="tab-button-group">{renderTabBtnList()}</div>
              <div className="right">
                <MultiSelectComp
                  label="车辆类型"
                  options={useCaseList}
                  onChange={handleChangeUseCaseList}
                  clstag={CLSTAG.MultiPage_VehicleType_Select}
                />
                <SelectComp
                  label="车辆业务"
                  options={business}
                  onChange={handleChangeBusinessType}
                  clstag={CLSTAG.MultiPage_BusinessType_Select}
                />
                <ButtonRadio btnGroup={Mode} onChange={handleChangeMode} />
              </div>
            </div>
            {activeMode === 'mapMode' && (
              <div className="bread-line">
                <CommonBreadCrumb config={breadConfig} />
              </div>
            )}
            {activeMode === 'boardMode' && (
              <div className="line2">{renderSubTabBtnList()}</div>
            )}
          </div>
          {activeMode === 'boardMode' ? (
            searchCondition.currentCategory != 'CONNECTION_LOST' ? (
              <BoardMode
                key={boardListKey}
                cockpitNum={cockpitNum}
                totalSize={
                  (tabBtnListMap &&
                    tabBtnListMap.get(searchCondition.currentCategory).value) ||
                  0
                }
                searchCondition={searchCondition}
                handleClickStopItem={handleClickStopItem}
                handleScheduleModel={handleScheduleModel}
              />
            ) : (
              <BoardGroup
                key={boardListKey}
                searchCondition={searchCondition}
                cockpitNum={cockpitNum}
                updateGroupTotal={updateGroupTotal}
                handleClickStopItem={handleClickStopItem}
                handleScheduleModel={handleScheduleModel}
                activeSubTabId={activeSubTabId}
              />
            )
          ) : (
            <MapMode
              mapData={mapData}
              key={boardListKey}
              handleClickCityLevel={handleClickCityLevel}
              handleClickStationIcon={handleClickStationIcon}
              showZoomInfo={true}
            />
          )}
        </div>
      </div>
      <Modal
        visible={modalVisible}
        title={modalTitle}
        className="my-modal re-modal"
        width="1100px"
        destroyOnHidden={true}
        onOk={(e) => {
          e.stopPropagation();
          setModalVisible(false);
        }}
        onCancel={(e) => {
          e.stopPropagation();
          setModalVisible(false);
        }}
        footer={null}
        maskClosable={false}
      >
        <OrderList
          key={stopData && stopData.id}
          vehicleName={stopData && stopData.name}
          visible={modalVisible}
          scheduleState={stopData && stopData.scheduleState}
          stopList={stopData && stopData.stopList}
          goalId={stopData && stopData.id}
          stopAction={stopData && stopData.stopAction}
          updateModalTitle={updateModalTitle}
        ></OrderList>
      </Modal>

      <ScheduleModel
        visible={visible}
        setVisibleCb={(e: any) => {
          setVisible(!visible);
        }}
        vehicleName={scheduleVehicle}
      />
    </>
  );
};

export default React.memo(RealTime);
